import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {deleteInvSingle} from "../../../../../api/inventory/InvApi";
import useGoToNavigation from "../../../../../util/useGotoNavigation";


export const useDeleteInvSingle = () => {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation()
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: { inventoryId: number, }) => deleteInvSingle(data),
        onSuccess: (res: any) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "삭제되었습니다",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readInv"]})
                        goToNavigation("inventory/inv/list", {}, false)
                    }
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.message ?? res.data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
